import { enUS, fr } from 'date-fns/locale'

const dateFnsLocales = {
  en: enUS,
  fr: fr
}

export default dateFnsLocales
